// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaTrash, FaEdit, FaTimes, FaSearch } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const ShowAllServicePerson = () => {
//   const [servicepersons, setServicepersons] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedBlocks, setSelectedBlocks] = useState([]);
//   const [selectedPersonName, setSelectedPersonName] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const navigate = useNavigate();

//   const fetchServicepersons = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`https://api.inventory.galosolar.com/admin/all-service-persons`);
//       setServicepersons(response.data.allServicePersons);
//     } catch (error) {
//       alert("Failed to fetch service persons");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const deactivateServicePerson = async (id) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to deactivate this service person?"
//     );
//     if (!confirmDelete) return;

//     try {
//       await axios.delete(`https://api.inventory.galosolar.com/admin/deactivate-service-person?id=${id}`);
//       setServicepersons((prev) => prev.filter((person) => person._id !== id));
//       alert("Service person deactivated successfully");
//     } catch (error) {
//       alert(error.response?.data?.message || "Failed to deactivate");
//     }
//   };

//   const formatBlock = (block) => {
//     if (!block) return "NA";
//     if (Array.isArray(block)) return block.join(", ") || "NA";
//     return block;
//   };

//   const handleBlockClick = (block, personName, isActive) => {
//     if (!isActive) return; // Disable click if inactive
//     if (!block) return;
//     const blocksArray = Array.isArray(block) ? block : [block];
//     setSelectedBlocks(blocksArray);
//     setSelectedPersonName(personName);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setSelectedBlocks([]);
//     setSelectedPersonName("");
//   };

//   // Safe filter
//   const filteredServicepersons = servicepersons.filter((person) => {
//     if (!searchTerm) return true;
//     const term = searchTerm.toLowerCase();
//     return (
//       person.name?.toLowerCase().includes(term) ||
//       person.email?.toLowerCase().includes(term) ||
//       String(person.contact ?? "").toLowerCase().includes(term) ||
//       person.district?.toLowerCase().includes(term) ||
//       person.state?.toLowerCase().includes(term)
//     );
//   });

//   useEffect(() => {
//     fetchServicepersons();
//   }, []);

//   return (
//     <div className="h-screen flex flex-col p-4">
//       {/* Header with title and search */}
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
//         <h2 className="text-2xl font-bold">
//           Service Persons ({filteredServicepersons.length} / {servicepersons.length})
//         </h2>
//         <div className="relative w-full sm:w-64">
//           <input
//             type="text"
//             placeholder="Search by name, email, contact, district, state..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="w-full border rounded-md py-2 pl-10 pr-8 focus:outline-none focus:ring-2 focus:ring-yellow-400"
//           />
//           <FaSearch className="absolute left-3 top-3 text-gray-400" />
//           {searchTerm && (
//             <button
//               onClick={() => setSearchTerm("")}
//               className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600"
//             >
//               <FaTimes />
//             </button>
//           )}
//         </div>
//       </div>

//       {loading ? (
//         <div className="flex justify-center items-center h-full">Loading...</div>
//       ) : (
//         <div className="flex-1 border rounded-md overflow-hidden w-full">
//           <div className="h-full overflow-auto w-full">
//             <table className="min-w-[1000px] w-full border-collapse">
//               <thead className="bg-yellow-400 sticky top-0 z-10">
//                 <tr>
//                   <th className="p-3 border">Person Details (Name / Email / Contact)</th>
//                   <th className="p-3 border">Location (District / State)</th>
//                   <th className="p-3 border">Block</th>
//                   <th className="p-3 border">Coordinates (Longitude / Latitude)</th>
//                   <th className="p-3 border">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredServicepersons.length === 0 ? (
//                   <tr>
//                     <td colSpan="5" className="text-center p-6">
//                       {searchTerm ? "No matching service persons found" : "No service persons found"}
//                     </td>
//                   </tr>
//                 ) : (
//                   filteredServicepersons.map((item) => {
//                     const isActive = item.isActive !== false; // default true if field missing
//                     return (
//                       <tr
//                         key={item._id}
//                         className={`text-center hover:bg-gray-100 ${!isActive ? "opacity-60" : ""}`}
//                       >
//                         {/* Person Details */}
//                         <td className="p-3 border">
//                           <div><strong>{item.name}</strong></div>
//                           <div className="text-sm text-gray-600">{item.email}</div>
//                           <div className="text-sm text-gray-600">{item.contact}</div>
//                         </td>

//                         {/* Location */}
//                         <td className="p-3 border">
//                           <div>{item.district || "NA"}</div>
//                           <div className="text-sm text-gray-600">{item.state || "NA"}</div>
//                         </td>

//                         {/* Block - clickable only if active */}
//                         <td
//                           className={`p-3 border max-w-[250px] truncate ${
//                             isActive ? "cursor-pointer hover:underline" : "cursor-not-allowed"
//                           }`}
//                           title={isActive ? formatBlock(item.block) : "Inactive – view disabled"}
//                           onClick={() => handleBlockClick(item.block, item.name, isActive)}
//                         >
//                           {formatBlock(item.block)}
//                         </td>

//                         {/* Coordinates */}
//                         <td className="p-3 border">
//                           <div>Long: {item.longitude || "NA"}</div>
//                           <div>Lat: {item.latitude || "NA"}</div>
//                         </td>

//                         {/* Actions */}
//                         <td className="p-3 border">
//                           <div className="flex justify-center gap-2">
//                             <button
//                               onClick={() => navigate("/EditServicePerson", { state: item })}
//                               disabled={!isActive}
//                               className={`px-3 py-2 rounded ${
//                                 isActive
//                                   ? "bg-green-500 hover:bg-green-600 text-white"
//                                   : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                               }`}
//                               title={isActive ? "Edit" : "Inactive – editing disabled"}
//                             >
//                               <FaEdit />
//                             </button>
//                             <button
//                               onClick={() => deactivateServicePerson(item._id)}
//                               disabled={!isActive}
//                               className={`px-3 py-2 rounded ${
//                                 isActive
//                                   ? "bg-red-500 hover:bg-red-600 text-white"
//                                   : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                               }`}
//                               title={isActive ? "Deactivate" : "Inactive – deactivation disabled"}
//                             >
//                               <FaTrash />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {/* Modal for blocks */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
//             <div className="flex justify-between items-center mb-4">
//               <h3 className="text-xl font-semibold">
//                 Blocks Assigned to {selectedPersonName}
//               </h3>
//               <button
//                 onClick={closeModal}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <FaTimes size={20} />
//               </button>
//             </div>
//             <div className="max-h-96 overflow-y-auto">
//               {selectedBlocks.length === 0 ? (
//                 <p className="text-gray-500">No blocks assigned</p>
//               ) : (
//                 <ul className="list-disc pl-5 space-y-1">
//                   {selectedBlocks.map((block, index) => (
//                     <li key={index} className="text-gray-700">
//                       {block}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//             <div className="mt-6 flex justify-end">
//               <button
//                 onClick={closeModal}
//                 className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ShowAllServicePerson;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaTrash, FaEdit, FaTimes, FaSearch, FaUndo } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ShowAllServicePerson = () => {
  const [servicepersons, setServicepersons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedBlocks, setSelectedBlocks] = useState([]);
  const [selectedPersonName, setSelectedPersonName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const fetchServicepersons = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://api.inventory.galosolar.com/admin/all-service-persons`);
      setServicepersons(response.data.allServicePersons);
    } catch (error) {
      alert("Failed to fetch service persons");
    } finally {
      setLoading(false);
    }
  };

  const toggleServicePersonStatus = async (id, currentStatus) => {
    const newStatus = !currentStatus;
    const confirmMsg = newStatus
      ? "Are you sure you want to activate this service person?"
      : "Are you sure you want to deactivate this service person?";
    const confirmAction = window.confirm(confirmMsg);
    if (!confirmAction) return;

    try {
      await axios.delete(
        `https://api.inventory.galosolar.com/admin/deactivate-service-person?id=${id}&status=${newStatus}`
      );
      setServicepersons((prev) =>
        prev.map((person) =>
          person._id === id ? { ...person, isActive: newStatus } : person
        )
      );
      alert(
        newStatus
          ? "Service person activated successfully"
          : "Service person deactivated successfully"
      );
    } catch (error) {
      alert(error.response?.data?.message || "Failed to update status");
    }
  };

  const formatBlock = (block) => {
    if (!block) return "NA";
    if (Array.isArray(block)) return block.join(", ") || "NA";
    return block;
  };

  const handleBlockClick = (block, personName, isActive) => {
    if (!isActive) return; // Disable click if inactive
    if (!block) return; 
    const blocksArray = Array.isArray(block) ? block : [block];
    setSelectedBlocks(blocksArray);
    setSelectedPersonName(personName);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedBlocks([]);
    setSelectedPersonName("");
  };

  // Safe filter
  const filteredServicepersons = servicepersons.filter((person) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      person.name?.toLowerCase().includes(term) ||
      person.email?.toLowerCase().includes(term) ||
      String(person.contact ?? "").toLowerCase().includes(term) ||
      person.district?.toLowerCase().includes(term) ||
      person.state?.toLowerCase().includes(term)
    );
  });

  useEffect(() => {
    fetchServicepersons();
  }, []);

  return (
    <div className="h-screen flex flex-col p-4">
      {/* Header with title and search */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
        <h2 className="text-2xl font-bold">
          Service Persons ({filteredServicepersons.length} / {servicepersons.length})
        </h2>
        <div className="relative w-full sm:w-64">
          <input
            type="text"
            placeholder="Search by name, email, contact, district, state..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full border rounded-md py-2 pl-10 pr-8 focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
          <FaSearch className="absolute left-3 top-3 text-gray-400" />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm("")}
              className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600"
            >
              <FaTimes />
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-full">Loading...</div>
      ) : (
        <div className="flex-1 border rounded-md overflow-hidden w-full">
          <div className="h-full overflow-auto w-full">
            <table className="min-w-[1000px] w-full border-collapse">
              <thead className="bg-yellow-400 sticky top-0 z-10">
                <tr>
                  <th className="p-3 border">Person Details (Name / Email / Contact)</th>
                  <th className="p-3 border">Location (District / State)</th>
                  <th className="p-3 border">Block</th>
                  <th className="p-3 border">Coordinates (Longitude / Latitude)</th>
                  <th className="p-3 border">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredServicepersons.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center p-6">
                      {searchTerm ? "No matching service persons found" : "No service persons found"}
                    </td>
                  </tr>
                ) : (
                  filteredServicepersons.map((item) => {
                    const isActive = item.isActive !== false; // default true if field missing
                    return (
                      <tr
                        key={item._id}
                        className={`text-center hover:bg-gray-100 ${!isActive ? "opacity-60" : ""}`}
                      >
                        {/* Person Details */}
                        <td className="p-3 border">
                          <div><strong>{item.name}</strong></div>
                          <div className="text-sm text-gray-600">{item.email}</div>
                          <div className="text-sm text-gray-600">{item.contact}</div>
                        </td>

                        {/* Location */}
                        <td className="p-3 border">
                          <div>{item.district || "NA"}</div>
                          <div className="text-sm text-gray-600">{item.state || "NA"}</div>
                        </td>

                        {/* Block - clickable only if active */}
                        <td
                          className={`p-3 border max-w-[250px] truncate ${
                            isActive ? "cursor-pointer hover:underline" : "cursor-not-allowed"
                          }`}
                          title={isActive ? formatBlock(item.block) : "Inactive – view disabled"}
                          onClick={() => handleBlockClick(item.block, item.name, isActive)}
                        >
                          {formatBlock(item.block)}
                        </td>

                        {/* Coordinates */}
                        <td className="p-3 border">
                          <div>Long: {item.longitude || "NA"}</div>
                          <div>Lat: {item.latitude || "NA"}</div>
                        </td>

                        {/* Actions */}
                        <td className="p-3 border">
                          <div className="flex justify-center gap-2">
                            <button
                              onClick={() => navigate("/EditServicePerson", { state: item })}
                              disabled={!isActive}
                              className={`px-3 py-2 rounded ${
                                isActive
                                  ? "bg-green-500 hover:bg-green-600 text-white"
                                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
                              }`}
                              title={isActive ? "Edit" : "Inactive – editing disabled"}
                            >
                              <FaEdit />
                            </button>

                            {isActive ? (
                              <button
                                onClick={() => toggleServicePersonStatus(item._id, isActive)}
                                className="px-3 py-2 rounded bg-red-500 hover:bg-red-600 text-white"
                                title="Deactivate"
                              >
                                <FaTrash />
                              </button>
                            ) : (
                              <button
                                onClick={() => toggleServicePersonStatus(item._id, isActive)}
                                className="px-3 py-2 rounded bg-blue-500 hover:bg-blue-600 text-white"
                                title="Activate"
                              >
                                <FaUndo />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal for blocks */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">
                Blocks Assigned to {selectedPersonName}
              </h3>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes size={20} />
              </button>
            </div>
            <div className="max-h-96 overflow-y-auto">
              {selectedBlocks.length === 0 ? (
                <p className="text-gray-500">No blocks assigned</p>
              ) : (
                <ul className="list-disc pl-5 space-y-1">
                  {selectedBlocks.map((block, index) => (
                    <li key={index} className="text-gray-700">
                      {block}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShowAllServicePerson;